export enum InvoiceBalanceModifierReference {
  BankPayment = 'bankPayment',
  ContactBalancePayment = 'contactBalancePayment',
  DaybookTransaction = 'daybookTransaction',
  Invoice = 'invoice',
  InvoiceLateFee = 'invoiceLateFee',
  ExternalInvoice = 'externalInvoice',
  CreditNote = 'creditnote',
}
